import { SignIn } from '@clerk/clerk-react';
import { css } from '@styled-system/css';

export const SignInPage = () => {
  return (
    <div
      className={css({
        minHeight: '100vh',
        bg: 'background.primary',
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
        pt: '6rem',
      })}
    >
      <SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" />
    </div>
  );
};
